import { render } from "./LogoutView.vue?vue&type=template&id=ae580e12&scoped=true"
import script from "./LogoutView.vue?vue&type=script&lang=js"
export * from "./LogoutView.vue?vue&type=script&lang=js"

import "./LogoutView.vue?vue&type=style&index=0&id=ae580e12&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae580e12"]])

export default __exports__